import { ChartDataPoint, DashboardPeriod, PERIOD_LABELS } from '@/lib/api/dashboard/dashboard-api'
import {
    CartesianGrid,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts'

interface ConsultationsChartProps {
    data: ChartDataPoint[]
    period: DashboardPeriod
}

export default function ConsultationsChart({ data, period }: ConsultationsChartProps) {
    const total = data.reduce((sum, d) => sum + d.value, 0)

    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 p-5">
            <div className="flex items-center justify-between mb-4">
                <div>
                    <h3 className="text-lg font-semibold text-base-content">
                        Consultas
                    </h3>
                    <p className="text-sm text-base-content/60">
                        {PERIOD_LABELS[period]}
                    </p>
                </div>
                <div className="text-right">
                    <p className="text-2xl font-bold text-info">{total}</p>
                    <p className="text-xs text-base-content/60">Total</p>
                </div>
            </div>

            {data.length === 0 ? (
                <div className="flex items-center justify-center h-64 text-base-content/50">
                    Sem dados no período
                </div>
            ) : (
                <div className="w-full" style={{ height: '250px', minHeight: '250px' }}>
                    <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
                            <XAxis
                                dataKey="label"
                                tick={{ fontSize: 12 }}
                                tickLine={false}
                                axisLine={false}
                            />
                            <YAxis
                                tick={{ fontSize: 12 }}
                                tickLine={false}
                                axisLine={false}
                                allowDecimals={false}
                            />
                            <Tooltip
                                contentStyle={{
                                    backgroundColor: 'oklch(var(--b1))',
                                    border: '1px solid oklch(var(--b3))',
                                    borderRadius: '8px',
                                }}
                                formatter={(value) => [value ?? 0, 'Consultas']}
                            />
                            <Line
                                type="monotone"
                                dataKey="value"
                                stroke="#0ea5e9"
                                strokeWidth={2}
                                dot={{ fill: '#0ea5e9', strokeWidth: 2 }}
                                activeDot={{ r: 6 }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    )
}
